import styled from 'styled-components';

export const Container = styled.div`
  width: 700px;
  margin: 0 auto;
  @media (max-width: 991px) {
    width: auto;
  }
`;
export const Title = styled.h1`
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0px;
  margin: 25px 0;
  text-align: center;
`;
export const MainInfoContent = styled.div`
  background: #ffffffcc;
  border-top: 1px solid #e2e8f0;
  border-radius: 24px;
  box-shadow: 0px 8px 10px -6px #0000001a;
  box-shadow: 0px 20px 25px -5px #0000001a;
  padding: 33px;
  @media (max-width: 767px) {
    padding: 16px;
  }
`;
export const MainInfoTab = styled.div`
  display: flex;
  gap: 25px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
export const TabBlock = styled.div`
  height: 114px;
  background: #ffffff99;
  border: 1px solid ${(props) => (props.isActive ? '#2d6cdf' : '#e2e8f0')};
  box-shadow: 0px 3.3px 4.94px -3.3px #0000001a;
  box-shadow: 0px 8.24px 12.36px -2.47px #0000001a;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: #f8fafc;
  }
`;
export const TabBlockTitle = styled.h4`
  font-weight: 700;
  font-size: 17.81px;
  line-height: 23.75px;
  text-align: center;
  color: ${(props) => (props.isActive ? '#2d6cdf' : '#000')};
`;
export const TabBlockSubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${(props) => (props.isActive ? '#2d6cdf' : '#6c757d')};
`;
export const TabContent = styled.div`
  margin-top: 35px;
`;
export const TabContentTitle = styled.h5`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #212529;
  text-align: center;
`;
export const InputGroup = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  margin-top: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
  }
`;
export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  flex: ${(props) => props.flex || 1};
  > div {
    min-height: auto;
  }

  input {
    height: 60px;
    padding: 20px;
    border-radius: 14px;
    border: 2px solid ${(props) => (props.hasError ? '#e45270' : '#e2e8f0')};
    background: #f8fafc;
    box-shadow: 0px 1px 2px -1px #0000001a;
    box-shadow: 0px 1px 3px 0px #0000001a;
    font-size: 16px;
    color: #212529;
    outline: none;
    transition: all 0.2s;

    &::placeholder {
      color: #90a1b9;
    }

    &:focus {
      border-color: ${(props) => (props.hasError ? '#e45270' : '#2d6cdf')};
    }
  }
  .apt-label {
    height: 22px;
    display: flex;
    align-items: center;
    gap: 2px;
  }
`;
export const Label = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: #212529;
  margin-bottom: 3px;
  span {
    font-weight: 500;
    font-size: 16px;
    color: #e45270;
  }
`;

export const SuggestionList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-top: 4px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  list-style: none;
  padding: 8px 0;
`;

export const SuggestionItem = styled.li`
  padding: 10px 16px;
  cursor: pointer;
  &:hover {
    background: #f1f5f9;
  }
`;
export const AptImg = styled.img``;

export const ErrorMessage = styled.div`
  color: #e45270;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
`;
